var React = require('react');

function MoreVertical (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"2","cy":"2","r":"2","fill":"currentColor","key":0}),React.createElement("circle",{"cx":"2","cy":"8","r":"2","fill":"currentColor","key":1}),React.createElement("circle",{"cx":"2","cy":"14","r":"2","fill":"currentColor","key":2})]);
}

MoreVertical.defaultProps = {"width":"4","height":"16","viewBox":"0 0 4 16","fill":"none"};

module.exports = MoreVertical;

MoreVertical.default = MoreVertical;
